<section class="contact-section">
  <div class="cta-overlay"></div>
  <div class="container position-relative" style="z-index: 2;">

    @if (!isSubmittedSuccessfully) {
    <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
      <div class="container-fluid py-5 px-0">
        <div class="row mx-0 justify-content-center">
          <div class="col-lg-6 col-md-8 col-sm-10 px-0">
            <div class="contact-form bg-white rounded p-5 shadow-lg">
              <div id="success"></div>

              <!-- Nombre -->
              <div class="control-group mb-4">
                <label for="name" class="form-label">Nombre: </label>
                <input type="text" class="form-control bg-light border-0 p-4 w-100" id="name" formControlName="name"
                  placeholder="Nombre y Apellido" autocomplete="name" />
                @if (contactForm.get('name')?.invalid && contactForm.get('name')?.touched) {
                <p class="help-block text-danger">Por favor ingrese su nombre</p>
                }
              </div>

              <!-- Email -->
              <div class="control-group mb-4">
                <label for="email" class="form-label">Email: </label>
                <input id="email" type="email" formControlName="email" class="form-control bg-light border-0 p-4 w-100"
                  placeholder="E-mail" autocomplete="email" />
                @if (contactForm.get('email')?.invalid && contactForm.get('email')?.touched) {
                <p class="help-block text-danger">Por favor ingrese su E-mail</p>
                }
              </div>

              <!-- Asunto -->
              <div class="control-group mb-4">
                <label for="subject" class="form-label">Asunto: </label>
                <select class="form-select bg-light border-0 p-4 w-100" id="subject" formControlName="subject"
                  autocomplete="off">
                  <option value="" disabled>Seleccione una opción</option>
                  @for (option of subjectOptions; track $index) {
                  <option [value]="option.value">{{ option.text }}</option>
                  }
                </select>
                @if (contactForm.get('subject')?.invalid && contactForm.get('subject')?.touched) {
                <p class="help-block text-danger">Por favor seleccione una opción</p>
                }
              </div>

              <!-- Comentario -->
              <div class="control-group mb-4">
                <label for="comment" class="form-label">Comentario: </label>
                <textarea id="comment" formControlName="comment" class="form-control bg-light border-0 py-3 px-4 w-100"
                  rows="5" placeholder="Mensaje" autocomplete="off"></textarea>
                @if (contactForm.get('comment')?.invalid && contactForm.get('comment')?.touched) {
                <p class="help-block text-danger">Por favor ingrese un mensaje</p>
                }
              </div>

              <!-- Botón Enviar -->
              <div class="text-center mt-4">
                <button class="btn btn-contact-form text-uppercase py-3 px-5 w-100" type="submit"
                  [disabled]="!contactForm.valid || isSubmitting" id="sendMessageButton">
                  {{ isSubmitting ? 'Enviando...' : 'Enviar' }}
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </form>
    } @else {
    <!-- MENSANE DE ÉXITO -->
    <div class="container-fluid py-5 px-0">
      <div class="row mx-0 justify-content-center">
        <div class="col-lg-6 col-md-8 col-sm-10 px-0">
          <div class="contact-form bg-white rounded p-5 shadow-lg text-center">

            <!-- Icono de Check de Bootstrap (SVG) -->
            <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="#fbd541"
              class="bi bi-check-circle-fill mb-4" viewBox="0 0 16 16">
              <path
                d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
            </svg>

            <h2 class="mb-3" style="color: #222429; font-weight: 600;">Mensaje enviado</h2>
            <p class="mb-4" style="color: #6c757d; font-size: 1.1rem;">
              Muchas gracias por contactarnos. Revisaremos su consulta y nos comunicaremos a la brevedad.
            </p>

            <!-- Botón opcional para volver al formulario -->
            <button class="btn btn-outline-secondary px-4 py-2" (click)="resetForm()" style="border-radius: 6px;">
              Enviar otro mensaje
            </button>

          </div>
        </div>
      </div>
    </div>
    }

  </div>
</section>